const VIPRedemptionMethod = {
  LOCQPay: "locqpay",
  Cash: "cash",
  PointsExpiry: "points-expiry",
};

export default VIPRedemptionMethod;
